import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AppointmentStatus} from "intake-shared";
import {MatMenuModule} from "@angular/material/menu";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";

/** "Pill" display of a transcription's state */
@Component({
	selector: 'app-status-pill',
	imports: [
		MatMenuModule,
		MatIconModule,
		MatButtonModule
	],
	templateUrl: 'appointment-status-pill.html',
	standalone: true,
	styleUrl: './appointment-status-pill.scss'
})
export class AppointmentStatusPillComponent {
	protected readonly AppointmentStatus = AppointmentStatus;

	/** Class to set for the component */
	class:string;

	/** Text for the pill */
	text:string;

	/** The current status of the appointment */
	private _status:AppointmentStatus;

	/** Emit when the user selects something */
	@Output()
	onStatusChange = new EventEmitter<AppointmentStatus>();

	/** The current status of the appointment */
	get status() {
		return this._status;
	}

	/** The current status of the appointment */
	@Input()
	set status(value:AppointmentStatus) {
		this._status = value;

		switch(value) {
			case AppointmentStatus.Scheduled:
				this.text = "Scheduled";
				this.class = "scheduled";
				break;
			case AppointmentStatus.Arrived:
				this.text = "Arrived";
				this.class = "arrived";
				break;
			case AppointmentStatus.CheckedIn:
				this.text = "Checked in";
				this.class = "checked-in";
				break;
			case AppointmentStatus.InVisit:
				this.text = "In Visit";
				this.class = "in-visit";
				break;
			case AppointmentStatus.CheckedOut:
				this.text = "Checked out";
				this.class = "checked-out";
				break;
		}
	}
}
